"use no memo";

import React, { useCallback, useMemo, useState } from 'react';

export const INITIAL_TIMER = 120;

export const OrderPollingTimerContext = React.createContext({
  resetTimer(): void {
    throw new Error('not implemented');
  },
  tickTimer(): void {
    throw new Error('not implemented');
  },
  timer: INITIAL_TIMER,
});

export default function OrderPollingTimerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [timer, setTimer] = useState(INITIAL_TIMER);

  const resetTimer = useCallback(() => {
    setTimer(INITIAL_TIMER);
  }, []);

  const tickTimer = useCallback(() => {
    setTimer((prevTimer) => Math.max(prevTimer - 1, 0));
  }, []);

  const contextValue = useMemo(
    () => ({ resetTimer, tickTimer, timer }),
    [resetTimer, tickTimer, timer]
  );

  return (
    <OrderPollingTimerContext.Provider value={contextValue}>
      {children}
    </OrderPollingTimerContext.Provider>
  );
}
